<script setup lang="ts">
import LoyaltyNotificationSettings from './LoyaltyNotificationSettings.vue'
import LoyaltyRecoverySettings from './recovery/LoyaltyRecoverySettings.vue'

import type { LoyaltyNotificationsConfigFields } from '@/types/types'

defineProps<{
  loyaltyNotificationsConfigFields: LoyaltyNotificationsConfigFields
}>()

const emit = defineEmits<{
  (e: 'update:loyalty-notification-config', value: LoyaltyNotificationsConfigFields): void
  (e: 'has-message-content-error', value: boolean): void
}>()

const { isSupportConnection } = useLocalStorage()
</script>

<template>
  <div class="space-y-5">
    <LoyaltyNotificationSettings
      :loyalty-notifications-config-fields="loyaltyNotificationsConfigFields"
      @has-message-content-error="emit('has-message-content-error', $event)"
      @update:loyalty-notification-config="emit('update:loyalty-notification-config', $event)"
    />

    <LoyaltyRecoverySettings v-if="isSupportConnection" />
  </div>
</template>

<style>
.brick-switch > span > span {
  white-space: pre-line;
}
</style>
